import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import ControlledWidthContainer from '../../../Community/Sections/ControlledWidthContainer/ControlledWidthContainer';
import Badge from '../../../Employer/Badge/Badge';
import { COMPANY_BADGE_TYPES_PROP } from '../../../Includes/CompanyProps';
import Slider from '../../../JobComponents/Silder/Slider';
import LeftRailLayout from '../../../LeftRailLayout/LeftRailLayout';
import './BadgeDisplayGridSection.scss';

export default class BadgeDisplayGridSection extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        companyBadges: PropTypes.arrayOf(
            PropTypes.shape({
                type: COMPANY_BADGE_TYPES_PROP,
                url: PropTypes.string,
            })
        ),
    };

    renderBadges = () => {
        const dots =
            this.props.companyBadges && this.props.companyBadges.length <= 8;
        const arrows =
            this.props.companyBadges && this.props.companyBadges.length > 8;
        const sliderSettings = {
            dots,
            infinite: true,
            arrows,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            adaptiveHeight: false,
            swipe: false,
        };

        return (
            <div className="badges-controlled-width">
                <NoSSR>
                    <Slider settings={sliderSettings}>
                        {this.props.companyBadges.map((badge, idx) => (
                            <div
                                className="badge-div"
                                key={`${badge.type}-${idx}`}
                            >
                                <a href={badge.url}>
                                    <Badge type={badge.type} />
                                </a>
                            </div>
                        ))}
                    </Slider>
                </NoSSR>
            </div>
        );
    };

    renderContent = () => {
        let content = (
            <ControlledWidthContainer>
                {this.props.children}
            </ControlledWidthContainer>
        );
        if (this.props.companyBadges && this.props.companyBadges.length) {
            content = (
                <LeftRailLayout mobileLayoutClass={'rail-content-on-top'}>
                    {/** TODO: refactor this not to use leftrail in the component level */}
                    <LeftRailLayout.LeftRail showLegacyRail={true}>
                        {this.renderBadges()}
                    </LeftRailLayout.LeftRail>
                    <LeftRailLayout.MainContent>
                        {this.props.children}
                    </LeftRailLayout.MainContent>
                </LeftRailLayout>
            );
        }
        return content;
    };

    render() {
        return (
            <div className="component-CompanyPages-Sections-BadgeDisplayGridSection">
                {this.renderContent()}
            </div>
        );
    }
}
